'use client'
import { useEffect, useState } from "react";
import styles from '@/app/styles/components/pages/shop/category-filter.module.scss'
import {getCDNImage} from "@/app/utils/ImageUtil";
import {event} from "@/gtag";

const CategoryFilter = ({ productCategories, onChange, defaultValue }) => {

    const [selected, setSelected] = useState(defaultValue)
    const [categoriesVisible, setCategoriesVisible] = useState(true)

    useEffect(() => {
        setSelected(defaultValue)
    }, [defaultValue])

    const handleSelect = (category) => {

        if (isSelected(category)) {
            setSelected(undefined)
        } else {
            setSelected(category)
        }

        event('category_filter', {
            category: category?.name,
            categoryId: category?.id
        })

        if (onChange) {
            onChange({
                category: isSelected(category) ? undefined : category?.id
            })
        }
    }

    const isSelected = (category) => {
        return category?.id === selected?.id
    }

    const renderCategories = (categories) => {
        if (!categories) {
            return ''
        }

        let result = []

        for (let category of categories) {

            const imageStyle = {
                backgroundImage: `url(${getCDNImage(category?.acf?.image)})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
                backgroundPositionY: 'center'
            }
            const imageStyleActive = {
                backgroundImage: `url(${getCDNImage(category?.acf?.active_image)})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
                backgroundPositionY: 'center'
            }


            result.push(<div className={isSelected(category) ? styles.categoryFilterSelected : styles.categoryFilter}
                onClick={() => handleSelect(category)}
                key={'product-category-' + category.id}>
                <div style={imageStyleActive} className={`${styles.image} ${styles.imageActive}`} />
                <div style={imageStyle} className={`${styles.image} ${styles.imageInActive}`} />
                <h3>{category.name}</h3>
            </div>)
        }

        return result
    }

    const toggleCategoryContainer = () => {
        setCategoriesVisible(!categoriesVisible)
    }

    return <div>
        <div className={styles.toggleCategoryContainer} onClick={() => toggleCategoryContainer()} >
            <p>Izaberite kategoriju poklona</p>
            <div className={styles.arrowContainer}>
                <img
                    className={categoriesVisible ? styles.arrowUp : styles.arrowDown} src={'/arrow-right.png'}
                    alt="Strelica"
                    width={16}
                    height={16}
                />
            </div>
            <div className={styles.imageContainer}>
                {/* Image of the current category, nothing if no category selected */}
                {selected && <img src={selected?.acf?.image} alt={selected?.name} />}
                {selected && <p>{selected?.name}</p>}
            </div>
        </div>
        <div className={categoriesVisible ? styles.categoryFilterContainer : styles.hiddenCategory}>
            {renderCategories(productCategories)}
        </div>
    </div>
}

export default CategoryFilter